import { LearnerForm } from "@/features/learner/components/LearnerForm";

const LearnerCreate = () => {
  return <LearnerForm />;
};

export default LearnerCreate;
